import React, {useEffect, useState} from 'react';
import {FaReply, FaUser} from 'react-icons/fa';
import {
  Dimensions,
  FlatList,
  TouchableWithoutFeedback,
  View,
  StyleSheet
} from 'react-native';
import {Button, Col, Container, Row} from 'react-bootstrap';
import HomeHeader from '../../components/HomeHeader';
import {useLinkTo} from '@react-navigation/native';
import {Card, ListItem, Text} from 'react-native-elements';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

function ItemView(props) {
  return (
    <ListItem
      bottomDivider
      containerStyle={{backgroundColor: '#e10808'}}
      style={{margin: 10}}>
      <FaUser color="white" size={29} />
      <ListItem.Content>
        <ListItem.Title style={{color: 'white'}}>
          {props.item.repliedby}
        </ListItem.Title>
        <ListItem.Subtitle style={{color: 'white', alignSelf: 'flex-start'}}>
          {props.item.description}
        </ListItem.Subtitle>
      </ListItem.Content>
      <ListItem.Subtitle
        style={{color: 'white', fontSize: 10, alignSelf: 'flex-start'}}>
        {props.item.repliedon}
      </ListItem.Subtitle>
      {/* <ListItem.Title style={{color: '#e10808'}}>
        {props.item.is_closed === 0 ? 'Active' : 'Closed'}
      </ListItem.Title> */}
    </ListItem>
  );
}

export default function ReplyToComplaintScreen(props) {
  
  const linkTo = useLinkTo();
  
  const [complaint, setComplaint] = useState(
    JSON.parse(props.route.params.complaint),
  );

  useEffect(() => {}, []);

  const keyExtractor = (item, index) => index.toString();

  const renderer = ({item, index}) => (
    <ItemView navigation={props.navigation} item={item} index={index} />
  );

  const onReplyPress = () => {
    linkTo('/customers/file_reply_to_complaint?id=' + complaint.id);
  };

  const onPress = () => {
    linkTo(
      '/customers/complaint_details?opening=' +
        complaint.opening_remark +
        '&ticketno=' +
        complaint.ticketno +
        '&closing=' +
        complaint.closing_remark,
    );
  };

  return (
    <View style={styles.viewStyle}>
      <HomeHeader navigation={props.navigation} />
      <Container>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <TouchableWithoutFeedback onPress={onPress}>
              <Card
                containerStyle={{
                  backgroundColor: '#e10808',
                  borderWidth: 0,
                  elevation: 10,
                  borderRadius: 5,
                }}>
                <Card.Title style={{color: 'white'}}>
                  Ticket #{complaint.ticketno}
                </Card.Title>
                <Card.Divider />
                <Text
                  numberOfLines={1}
                  onPress={onPress}
                  style={{
                    marginBottom: 10,
                    color: 'white',

                    fontSize: 16,
                  }}>
                  {complaint.opening_remark}
                </Text>
                <Text
                  numberOfLines={1}
                  style={{marginBottom: 10, color: 'orange', fontSize: 16}}>
                  {complaint.closing_remark}
                </Text>
              </Card>
            </TouchableWithoutFeedback>
          </Col>
          <Col md={3}></Col>
        </Row>
        <Row>
          <Col md={3}></Col>
          <Col md={6}>
            <FlatList
              data={complaint.reply_lbl}
              keyExtractor={keyExtractor}
              renderItem={renderer}
            />
          </Col>
          <Col md={3}></Col>
        </Row>
        {complaint.is_closed != 1 && (
          <Row>
            <Col md={3}></Col>
            <Col md={6}>
              <Button
                onClick={onReplyPress}
                style={{
                  backgroundColor: '#e10808',
                  float: 'right',
                  marginRight: 20,
                  justifyContent: 'center',
                }}
                variant="danger">
                <FaReply
                  style={{
                    justifySelf: 'center',
                    marginRight: 5,
                  }}
                />{' '}
                Reply to complaint
              </Button>
            </Col>
            <Col md={3}></Col>
          </Row>
        )}
      </Container>
    </View>
  );
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT
  },
  indicatorStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flex: 1,
  },
  container: {
    flex: 1
  },
  content:{
    width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 2,
    paddingVertical: 16,
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
  }
});